import spinSrc from '../assets/sounds/spin.mp3';

const SND = (() => {
  let ctx, master, noise, spinAudio, fade, on = true;

  function init() {
    if (ctx) return;
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
      master = ctx.createGain();
      master.gain.value = 0.7;
      master.connect(ctx.destination);
      noise = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
      const d = noise.getChannelData(0);
      let last = 0;
      for (let i = 0; i < d.length; i++) {
        last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02;
        d[i] = last * 3.5;
      }
    } catch (e) {
      ctx = null;
    }
  }
  const ok = () => ctx && on;
  function wake() {
    init();
    if (ctx && ctx.state === 'suspended') ctx.resume();
  }
  function tone(f, dur, type = 'sine', vol = 0.2, f2, delay = 0) {
    if (!ok()) return;
    const t = ctx.currentTime + delay;
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f, t);
    if (f2) o.frequency.exponentialRampToValueAtTime(f2, t + dur);
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(vol, t + 0.005);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.03);
  }
  function burst(dur, freq, vol) {
    if (!ok()) return;
    const t = ctx.currentTime;
    const s = ctx.createBufferSource(), f = ctx.createBiquadFilter(), g = ctx.createGain();
    s.buffer = noise; f.type = 'bandpass'; f.frequency.value = freq; f.Q.value = 1.2;
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    s.connect(f); f.connect(g); g.connect(master); s.start(t, Math.random()); s.stop(t + dur + 0.02);
  }

  return {
    wake,
    get on() { return on; },
    toggle() { on = !on; if (!on) this.rollStop(); return on; },
    chip() { tone(1300, 0.05, 'square', 0.06, 600); burst(0.05, 2500, 0.5); },
    rollStart() {
      if (!on) return;
      if (!spinAudio) { spinAudio = new Audio(spinSrc); spinAudio.preload = 'auto'; }
      clearInterval(fade);
      spinAudio.currentTime = 0;
      spinAudio.volume = 0.9;
      const pr = spinAudio.play();
      if (pr && pr.catch) pr.catch(() => {});
    },
    rollStop() {
      if (!spinAudio || spinAudio.paused) return;
      clearInterval(fade);
      fade = setInterval(() => {
        if (spinAudio.volume > 0.08) spinAudio.volume = Math.max(0, spinAudio.volume - 0.1);
        else { spinAudio.pause(); clearInterval(fade); }
      }, 35);
    },
    tick(v) { tone(2000 + Math.random() * 900, 0.03, 'triangle', 0.1 + 0.15 * v, 900); burst(0.03, 3000, 0.25 * v); },
    clack() { tone(1100 + Math.random() * 400, 0.07, 'square', 0.12, 400); burst(0.06, 1800, 0.7); },
    land() { tone(180, 0.25, 'sine', 0.35, 70); burst(0.12, 900, 0.9); tone(880, 0.5, 'sine', 0.12, null, 0.12); },
    win(big) {
      const n = big ? [523.25, 659.25, 783.99, 1046.5, 1318.5, 1568, 2093] : [523.25, 659.25, 783.99, 1046.5];
      n.forEach((f, i) => { tone(f, 0.38, 'triangle', 0.2, null, i * 0.11); tone(f * 2, 0.3, 'sine', 0.06, null, i * 0.11); });
      const k = big ? 22 : 12;
      for (let i = 0; i < k; i++) tone(2200 + Math.random() * 1800, 0.12, 'sine', 0.07, null, 0.3 + i * (big ? 0.09 : 0.1));
    },
    lose() { tone(330, 0.35, 'sawtooth', 0.07, 160); tone(247, 0.5, 'sawtooth', 0.07, 110, 0.2); },
  };
})();

export default SND;
